/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  '>.MuiBox-root >.MuiBox-root >.MuiContainer-root': {
    maxWidth: 'unset',
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}));
